var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",staticClass:"clear-finder-style",staticStyle:{"max-width":"900px"},attrs:{"data":_vm.tableData,"setting":_vm.setting,"no-selection":"","show-pager":false}}),_c('el-button',{staticStyle:{"margin-top":"12px"},attrs:{"type":"primary"},on:{"click":_vm.handleAddCoupon}},[_vm._v("设置赠券")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }